import React from 'react';
import { Cloud, Mail, Github, ArrowRight, AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const NoIntegrationsPrompt = ({ projectId }) => {
  const navigate = useNavigate();

  const handleConnectIntegrations = () => {
    // The only surface that can actually connect an integration is the
    // wizard's ConnectIntegrationsStep (step 2). Two nearby pages look right
    // and aren't: /settings' GitHub button only re-runs OAuth, which never
    // satisfies the App-installation check this prompt reports, and
    // /compliance/projects/:id/integrations is read-only status cards.
    // ComplianceContext.restoreFromParams reads project_id + step, so the
    // wizard resumes on an existing project rather than creating a new one.
    if (projectId) {
      navigate(`/compliance/new?project_id=${projectId}&step=2`);
      return;
    }
    navigate('/settings', { state: { activeTab: 'integrations' } });
  };

  return (
    <div className="bg-amber-50 border-2 border-amber-200 rounded-lg p-4 sm:p-6 mt-6">
      <div className="flex flex-col sm:flex-row items-start gap-4">
        <div className="flex-shrink-0">
          <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center">
            <AlertTriangle className="w-6 h-6 text-amber-600" />
          </div>
        </div>

        <div className="flex-1">
          <h3 className="text-lg font-semibold text-amber-900 mb-2">
            No Integrations Connected
          </h3>
          <p className="text-sm text-amber-700 mb-4">
            Connect your cloud infrastructure and services to automatically verify compliance controls.
            Without integrations, all controls will require manual evidence upload.
          </p>

          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-500 rounded flex items-center justify-center">
                <Cloud className="w-4 h-4 text-white" />
              </div>
              <span className="text-xs font-medium text-gray-700">AWS</span>
            </div>

            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-blue-500 rounded flex items-center justify-center">
                <Mail className="w-4 h-4 text-white" />
              </div>
              <span className="text-xs font-medium text-gray-700">Google Workspace</span>
            </div>

            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-gray-900 rounded flex items-center justify-center">
                <Github className="w-4 h-4 text-white" />
              </div>
              <span className="text-xs font-medium text-gray-700">GitHub</span>
            </div>
          </div>

          <button
            onClick={handleConnectIntegrations}
            className="inline-flex w-full sm:w-auto justify-center items-center gap-2 px-4 py-2 min-h-[44px] bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors font-medium"
          >
            Connect Integrations
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoIntegrationsPrompt;
